import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { LogOut, UserCircle } from "lucide-react";

export function Header() {
  const { logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate("/login")
  }

  const handleProfileClick = () => {
    navigate("/profile")
  }

  const handleLogoClick = () => {
    navigate("/")
  }

  return (
    <header className="fixed top-0 z-50 w-full border-b bg-background/80 backdrop-blur-sm">
      <div className="flex h-16 items-center px-6">
        <div className="flex-1">
          <img
            src="https://epekdigital.com/wp-content/uploads/2024/08/EPEK-Digital.svg"
            alt="EpekDigital Logo"
            className="h-[40px] cursor-pointer"
            onClick={handleLogoClick}
          />
        </div>
        <div className="flex items-center gap-4 justify-end">
          <Button variant="ghost" size="icon" onClick={handleProfileClick}>
            <UserCircle className="h-5 w-5" />
          </Button>
          <Button variant="ghost" size="icon" onClick={handleLogout}>
            <LogOut className="h-5 w-5" />
          </Button>
        </div>
      </div>
    </header>
  )
}